type Args = {
  settingEnabled: boolean;
  isGuest: boolean;
  isCanceled: boolean;
  isQuickRequest: boolean;
  isCustomBroker: boolean;
  isMultistop: boolean;
  isBooked: boolean;
};

export const shouldShowPodAttachmentsCard = (args: Args): boolean =>
  args.settingEnabled &&
  !args.isGuest &&
  !args.isCanceled &&
  !args.isQuickRequest &&
  !args.isCustomBroker &&
  !args.isMultistop &&
  args.isBooked;
